import { pageQuery } from '../lib/egress.js';
import { supabase }  from '../supabase.js';
import { openFacDrill } from './drills.js';

export async function renderFacilitators() {
  const el = document.getElementById('view-facilitators');
  el.innerHTML = `
    <div class="page-header">
      <h1>Facilitators</h1>
      <p>People who can mark attendance; assigned to classes via Classes admin.</p>
    </div>
    <div class="table-card">
      <table class="data-table">
        <thead><tr>
          <th>Name</th><th>Email</th><th>Active</th><th>Classes assigned</th>
        </tr></thead>
        <tbody id="fa-tbody"><tr><td colspan="4" class="no-data">Loading…</td></tr></tbody>
      </table>
    </div>
  `;

  const [facs, classes] = await Promise.all([
    pageQuery('facilitators', { order: 'full_name', ascending: true }),
    pageQuery('classes',      { select: 'class_id,facilitator_id' }),
  ]);

  const byFac = {};
  for (const c of classes.data) {
    if (!c.facilitator_id) continue;
    byFac[c.facilitator_id] = (byFac[c.facilitator_id] || 0) + 1;
  }

  const tbody = document.getElementById('fa-tbody');
  tbody.innerHTML = facs.data.map(f => `
    <tr class="clickable-row" data-fac-id="${f.facilitator_id}" data-fac-name="${esc(f.full_name || '')}">
      <td><strong>${esc(f.full_name || '—')}</strong></td>
      <td>${esc(f.email || '—')}</td>
      <td><span class="badge ${f.is_active ? 'badge-green' : 'badge-gray'}">${f.is_active ? 'Yes' : 'No'}</span></td>
      <td>${byFac[f.facilitator_id] || 0}</td>
    </tr>
  `).join('');

  tbody.querySelectorAll('.clickable-row').forEach(row => {
    row.addEventListener('click', () => {
      openFacDrill({ facilitatorId: row.dataset.facId, facilitatorName: row.dataset.facName });
    });
  });
}

function esc(s) { return String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c])); }
